
import { useQuery } from '@apollo/client';
import { GET_FLYER } from '@/graphql/queries';
import { GetFlyerResponse } from '@/graphql/types';
import { flyerVar } from '@/graphql/state';

type Props = {
  flyerId?: string;
  schoolId?: string | null;
  districtId?: string | null;
}

export const useFlyer = ({ flyerId, schoolId, districtId }: Props) => (
    useQuery<GetFlyerResponse>(GET_FLYER, {
      fetchPolicy: 'network-only',
      variables: {
        input: {
          flyerId: Number(flyerId),
          schoolId: Number(schoolId),
          districtId: Number(districtId),
        }
      },
      onCompleted(data) {
        if(data.getFlyer) {
          flyerVar(data.getFlyer);
        }
      }
    })
);
